module.exports = __webpack_public_path__ + "img/hub2.bfd771b0.png";